import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-search",
  "use": "oc-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-search\"><path d=\"M352 435.2h320v48H352zM512 688h64v64h-64zM704 720h28.8v32H704zM764.8 720H960v32h-195.2zM704 784h28.8v32H704zM764.8 784H960v32h-195.2z\" /><path d=\"M704 848h28.8v32H704zM764.8 848H960v32h-195.2z\" /><path d=\"M896 435.2h-96v48h64l28.8 73.6H768V144h-64v412.8H320V144H256v412.8H131.2l28.8-73.6h64v-48H131.2L64 556.8v323.2h576v-64H128v-192h768v32h64v-99.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol